(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/bet-proposal/assets/javascripts/helpers/get-labels.js') >= 0) return;  svs.modules.push('/components/marketplace/bet-proposal/assets/javascripts/helpers/get-labels.js');
'use strict';

const BOMBEN = svs.utils.products.productIds.BOMBEN;
const formatDate = svs.components.lbUtils.helpers.formatDate.formatDate;
const getOutcomeLabel = _ref => {
  let description = _ref.description,
    eventTypeId = _ref.eventTypeId,
    outcomeNumber = _ref.outcomeNumber;
  if (eventTypeId === 4) {
    return outcomeNumber === 1 ? 'ö' : 'u';
  }
  return description;
};
const getBetButtonAriaLabel = _ref2 => {
  let productId = _ref2.productId,
    outcome = _ref2.outcome,
    isSelected = _ref2.isSelected,
    eventTypeId = _ref2.eventTypeId;
  let label = '';
  if (productId === BOMBEN) {
    label = outcome.description;
  } else {
    switch (outcome.outcomeNumber) {
      case 1:
        label = 'Etta';
        break;
      case 2:
        label = 'Kryss';
        break;
      case 4:
        label = 'Tvåa';
        break;
      default:
        break;
    }
    if (eventTypeId === 4) {
      label = outcome.outcomeNumber === 1 ? 'över' : 'under';
    }
  }
  if (isSelected && label !== '') {
    label = "".concat(label, ", markerad");
  }
  return label;
};
const getBetRowAriaLabel = _ref3 => {
  let productId = _ref3.productId,
    eventNumber = _ref3.eventNumber,
    eventDescription = _ref3.eventDescription,
    eventComment = _ref3.eventComment,
    matchStart = _ref3.matchStart,
    _ref3$selectedOutcome = _ref3.selectedOutcomes,
    selectedOutcomes = _ref3$selectedOutcome === void 0 ? {} : _ref3$selectedOutcome;
  let ariaLabel = "Match ".concat(eventNumber);
  const evtDesc = eventDescription === null || eventDescription === void 0 ? void 0 : eventDescription.replace('-', 'mot');
  ariaLabel += ", ".concat(evtDesc);
  if (eventComment) {
    ariaLabel += ", ".concat(eventComment);
  }
  if (productId !== BOMBEN) {
    const leansTowards = [];
    if (selectedOutcomes[1]) {
      leansTowards.push('etta');
    }
    if (selectedOutcomes[2]) {
      leansTowards.push('kryss');
    }
    if (selectedOutcomes[4]) {
      leansTowards.push('tvåa');
    }
    if (selectedOutcomes[1] || selectedOutcomes[2] || selectedOutcomes[4]) {
      ariaLabel += ', lutar åt: ';
      ariaLabel += leansTowards.join(', ');
    }
  } else if (matchStart) {
    ariaLabel += ", start ".concat(formatDate(new Date(matchStart), true, true, true));
  }
  return ariaLabel;
};
setGlobal('svs.components.marketplace.betProposal.helpers.getLabels', {
  getBetButtonAriaLabel,
  getBetRowAriaLabel,
  getOutcomeLabel
});

 })(window);